'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoadingIndicator = require('./LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingPage = function (_Component) {
  _inherits(LoadingPage, _Component);

  function LoadingPage() {
    _classCallCheck(this, LoadingPage);

    return _possibleConstructorReturn(this, (LoadingPage.__proto__ || Object.getPrototypeOf(LoadingPage)).apply(this, arguments));
  }

  _createClass(LoadingPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        _react2.default.createElement(
          'div',
          { className: 'LoadingPage-indicator' },
          _react2.default.createElement(_LoadingIndicator2.default, null)
        ),
        _react2.default.createElement(
          'h2',
          { className: 'LoadingPage-text' },
          this.props.text
        )
      );
    }
  }]);

  return LoadingPage;
}(_react.Component);

LoadingPage.propTypes = {
  text: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string.isRequired
};

LoadingPage.defaultProps = {
  className: 'LoadingPage'
};

exports.default = LoadingPage;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/LoadingPage.js
// module id = 560
// module chunks = 0